import main from "./routes/main";
import about from "./routes/about";
import reports from "./routes/reports";
import news from "./routes/news";
import newsItem from "./routes/news-item";
import team from "./routes/team";
import protection from "./routes/protection";
import form from "./routes/form";

export default {
  "/": main,
  "/about": about,
  "/reports": reports,
  "/news": news,
  "/news/:id": newsItem,
  "/team": team,
  "/team2": team,
  "/team3": team,
  "/protection": protection,
  "/form": form
};
